import { useMutation } from '@tanstack/react-query';

import type { PostChatFileUploadData } from './chatService';

import { ChatService } from './chatService';
import { ChatKey } from './keys';

export function useChatFileUpload() {
  return useMutation({
    mutationKey: [ChatKey.CHAT_FILE_UPLOAD],
    mutationFn: (data: PostChatFileUploadData) => ChatService.uploadChatFile(data).then((response) => response.data),
  });
}
